// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-table-row:hover {\n    background-color: rgb(200, 246, 255);\n}", "",{"version":3,"sources":["webpack://src/designer/component/element/table/mtable/style.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC","sourcesContent":[".custom-table-row:hover {\n    background-color: rgb(200, 246, 255);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
